import React, { useEffect, useState } from "react";
import { currentTimer} from "../../../base/callService/common";
import styles from "./scss/timer.module.scss";
let interval: any;


type ChatDialPadMainState ={
  date: string,
  day: string,
  month: string,
  year: string,
  time: string,
  amPm: string,
};

export default function CallDialTimer() {

  const [getCallDialPadMain,setCallDialPadMain] = useState<ChatDialPadMainState>({
    date: currentTimer().date,
    day: currentTimer().day,
    month: currentTimer().month,
    year: currentTimer().year,
    time: currentTimer().time,
    amPm: currentTimer().amPm
  });


  const TimerStart = () => {
    interval = setInterval(function() {
      let currentTime = currentTimer();
      setCallDialPadMain({
        ...getCallDialPadMain, time: currentTime.time, amPm: currentTime.amPm, date: currentTime.date,
        day: currentTime.day, month: currentTime.month, year: currentTime.year
      });
    }, 1000);
  };

  const clearRunningTimer = () => {
    clearInterval(interval);
    interval = undefined;
  };

  useEffect(() => {
    TimerStart();
    return () => {
      clearRunningTimer();
    };
  },[]);

  return (
    <>
      <div className={styles.topsections}>
        <h1>{getCallDialPadMain.time}<sup>{ getCallDialPadMain.amPm }</sup></h1>
        <h5>{getCallDialPadMain.day}, <b>{getCallDialPadMain.date} </b>
          {getCallDialPadMain.month + " " + getCallDialPadMain.year}</h5>
      </div>
    </>
  );
}